// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"acf0549e","128":"337c1b60","515":"14fe1500","788":"bbc821c3"}[chunkId] + ".chunk.js";
};